import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { claimedShopOnboardingPath } from "../../core/primitives/onboarding";
import { DEFAULT_ROUTE } from "../../core/primitives/routes";
import { clearInitialClaimToken, getInitialClaimToken } from "../../sentry";
import { ShopClaimController } from "./shop-claim-controller";
import { ShopClaimPage } from "./shop-claim-page";

/** The token was captured and scrubbed from the URL before the router started; it is read once here. */
export function ShopClaimRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [token] = useState(() => getInitialClaimToken());
  return (
    <Subtree
      key="shop-claim"
      controller={() =>
        new ShopClaimController(
          { token },
          pick(deps, "client", "session", "authHandler", "profileRepository", "storeRepository"),
          {
            close: (registered) => {
              clearInitialClaimToken();
              navigate(registered ? DEFAULT_ROUTE : "/login", { replace: true });
            },
            goToLogin: () => {
              clearInitialClaimToken();
              navigate("/login", { replace: true });
            },
            toClaimedShop: (storeId) => {
              clearInitialClaimToken();
              navigate(claimedShopOnboardingPath(storeId), { replace: true });
            },
          },
        )
      }
    >
      <ShopClaimPage />
    </Subtree>
  );
}
